const line = state => state.line
const lines = state => state.lines

export default {
  line,
  lines
}
